export interface NonPropertyTypesModel {
  HOLIDAY_LEGACY: number;
  TRAVEL: number;
  ADMIN: number;
  TRAINING: number;
  NOT_WORKING: number;
  PERSONAL_APPOINTMENT: number;
  HOLIDAY_HALF_DAY: number;
  HOLIDAY_FULL_DAY: number;

  getTypes(): TypeModel[];
  getLabel(id: number): string;
}

export interface TypeModel {
  id: number;
  label: string;
}

export class NonPropertyTypes implements NonPropertyTypesModel {
  readonly HOLIDAY_LEGACY: number = 201;
  readonly TRAVEL: number = 202;
  readonly ADMIN: number = 203;
  readonly TRAINING: number = 204;
  readonly NOT_WORKING: number = 205;
  readonly PERSONAL_APPOINTMENT: number = 206;
  readonly HOLIDAY_HALF_DAY: number = 207;
  readonly HOLIDAY_FULL_DAY: number = 8;

  private readonly types: TypeModel[] = [
    {id: this.HOLIDAY_LEGACY, label: 'Holiday - Legacy'},
    {id: this.TRAVEL, label: 'Travel'},
    {id: this.ADMIN, label: 'Admin'},
    {id: this.TRAINING, label: 'Training'},
    {id: this.NOT_WORKING, label: 'Not Working'},
    {id: this.PERSONAL_APPOINTMENT, label: 'Personal Appointment'},
    {id: this.HOLIDAY_HALF_DAY, label: 'Holiday - Half Day'},
    {id: this.HOLIDAY_FULL_DAY, label: 'Holiday - Full Day'}
  ];

  getTypes(): TypeModel[] {
    return this.types;
  }

  getLabel(id: number): string {
    const filterResult = this.types.filter(entry => entry.id === id);
    return filterResult.length ? filterResult[0].label : 'unknown';
  }
}
